import { apiClient } from "./authService";

export interface SupplierPayload {
  company_name?: string;
  company_country?: string;
  company_phone?: string | null;
  additional_country?: string;
  additional_phone?: string | null;
  supplier_name?: string;
  supplier_country?: string;
  supplier_phone?: string | null;
  banner?: string | null;
  active?: boolean | string | number;
}

type SupplierId = string;

export const fetchSuppliers = async () => {
  const res = await apiClient.get("/suppliers/all");
  return res.data;
};

export const getSupplier = async (id: SupplierId) => {
  if (!id) throw new Error("Supplier ID is required.");
  const res = await apiClient.get(`/suppliers/${id}`);
  return res.data;
};

export const createSupplier = async (
  payload: SupplierPayload,
  bannerFile?: File
) => {
  const form = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      form.append(key, String(value));
    }
  });
  if (bannerFile) form.append("banner", bannerFile);

  const res = await apiClient.post("/suppliers/create", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updateSupplier = async (
  id: SupplierId,
  payload: Partial<SupplierPayload>,
  bannerFile?: File
) => {
  if (!id) throw new Error("Supplier ID is required.");
  const form = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      form.append(key, String(value));
    }
  });
  if (bannerFile) form.append("banner", bannerFile);

  const res = await apiClient.patch(`/suppliers/update/${id}`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteSupplier = async (id: SupplierId) => {
  if (!id) throw new Error("Supplier ID is required.");
  const res = await apiClient.delete(`/suppliers/delete/${id}`);
  return res.data;
};

export const fetchSupplierExpenses = async (id: SupplierId, params?: any) => {
  if (!id) throw new Error("Supplier ID is required.");
  const res = await apiClient.get(`/suppliers/${id}/expenses`, { params });
  return res.data;
};

export const getSupplierExpenseById = async (
  id: SupplierId,
  expenseId: number
) => {
  if (!id) throw new Error("Supplier ID is required.");
  if (!expenseId) throw new Error("Expense ID is required.");
  const res = await apiClient.get(`/suppliers/${id}/expenses/${expenseId}`);
  return res.data;
};

export interface SupplierExpensesQuery {
  from?: string; // yyyy-mm-dd
  to?: string;   // yyyy-mm-dd
  page?: number;
  size?: number;
}

export const fetchAllSupplierExpenses = async (
  params?: SupplierExpensesQuery
) => {
  const res = await apiClient.get("/suppliers/expenses", { params });
  return res.data;
};
